import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <i className="bi bi-box-seam me-2"></i>
          AE Conrad Co.
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav me-auto">
            {user && (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    Dashboard
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="setupDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Setup
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="setupDropdown">
                    <li>
                      <Link className="dropdown-item" to="/categories">
                        Categories
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/items">
                        Items
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/jobs">
                        Jobs
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="inventoryDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Inventory
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="inventoryDropdown">
                    <li>
                      <Link className="dropdown-item" to="/inventory">
                        Summary
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/lots">
                        View Lots
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <Link className="dropdown-item" to="/inventory/add">
                        <i className="bi bi-plus-circle me-2"></i>Add Inventory
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/inventory/remove">
                        <i className="bi bi-dash-circle me-2"></i>Allocate Inventory
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/inventory/reconcile">
                        <i className="bi bi-clipboard-check me-2"></i>Reconcile
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/import">
                        <i className="bi bi-file-earmark-spreadsheet me-2"></i>Import CSV
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/transactions">
                    Ledger
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/reports">
                    <i className="bi bi-bar-chart me-1"></i>Reports
                  </Link>
                </li>
                {user.is_admin && (
                  <li className="nav-item">
                    <Link className="nav-link" to="/admin/users">
                      <i className="bi bi-people me-1"></i>Users
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
          <ul className="navbar-nav">
            {user ? (
              <>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="userDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-person-circle me-1"></i>{user.username}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                    <li>
                      <Link className="dropdown-item" to="/account/change-password">
                        <i className="bi bi-key me-2"></i>Change Password
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <button className="dropdown-item text-danger" onClick={handleLogout}>
                        <i className="bi bi-box-arrow-right me-2"></i>Logout
                      </button>
                    </li>
                  </ul>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/login">
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/register">
                    Register
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
